module.exports = __webpack_public_path__ + "img/certified_leadership.573b3b32.png";